import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import * as Constants from '../Constants';
import {
  BP_ACTION_ITEMS,
  bpActionListModalStyle,
  bpActionOverlayModalStyle,
} from './bpActions';

/**
 * Shared BP Actions overlay — list picker + optional PHP iframe.
 *
 * Usage anywhere:
 *   <BpActionsOverlay
 *     isOpen={this.state.actionListOpen}
 *     bp={this.state.actionListBp}
 *     onClose={this.closeActionList}
 *   />
 */
class BpActionsOverlay extends Component {
  state = {
    overlayOpen: false,
    overlayTitle: '',
    overlayUrl: '',
    overlayPost: false,
    overlayPostAction: '',
    overlayPostField: '',
    overlayBn: '',
  };

  formRef = React.createRef();
  frameName = `bp-action-frame-${Math.random().toString(36).slice(2, 9)}`;

  closeAll = () => {
    this.setState({
      overlayOpen: false,
      overlayTitle: '',
      overlayUrl: '',
      overlayPost: false,
      overlayPostAction: '',
      overlayPostField: '',
      overlayBn: '',
    });
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  closeOverlayOnly = () => {
    this.setState({
      overlayOpen: false,
      overlayTitle: '',
      overlayUrl: '',
      overlayPost: false,
      overlayPostAction: '',
      overlayPostField: '',
      overlayBn: '',
    });
  };

  runAction = (item) => {
    const bp = this.props.bp;
    const bn = bp && (bp.businessPartnerId || bp.bpId || bp.id);
    const title = item.label + (bn ? ' — BP ' + bn : '');

    if (item.reactPath && this.props.history) {
      this.closeAll();
      this.props.history.push(item.reactPath(bn));
      return;
    }

    if (item.post) {
      this.setState(
        {
          overlayOpen: true,
          overlayTitle: title,
          overlayPost: true,
          overlayPostAction: Constants.CS_PORTAL_BASE + item.action,
          overlayPostField: item.field,
          overlayBn: bn || '',
          overlayUrl: '',
        },
        () => {
          if (this.formRef.current) {
            this.formRef.current.submit();
          }
        }
      );
      if (typeof this.props.onClose === 'function') {
        this.props.onClose();
      }
      return;
    }

    this.setState({
      overlayOpen: true,
      overlayTitle: title,
      overlayPost: false,
      overlayUrl: Constants.csPortalIframeSrc(item.path(bn)),
    });
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  render() {
    const { isOpen, bp } = this.props;
    const bn = bp && (bp.businessPartnerId || bp.bpId || bp.id);
    const listOpen = !!isOpen && !this.state.overlayOpen;

    return (
      <>
        <Modal
          isOpen={listOpen}
          onRequestClose={this.closeAll}
          ariaHideApp={false}
          style={bpActionListModalStyle}
          contentLabel="BP Actions"
        >
          <div className="bp-actions-panel">
            <div className="bp-actions-panel-header">
              <div className="bp-actions-panel-heading">
                <span className="bp-actions-panel-kicker">Quick actions</span>
                <h5 className="bp-actions-panel-title">
                  BP Actions{bn ? ` — ${bn}` : ''}
                </h5>
                {bp && (bp.name || bp.businessPartnerName) ? (
                  <p className="bp-actions-panel-subtitle">
                    {bp.name || bp.businessPartnerName}
                  </p>
                ) : null}
              </div>
              <button
                type="button"
                className="bp-actions-panel-close"
                onClick={this.closeAll}
                aria-label="Close"
              >
                <span className="mdi mdi-close" />
              </button>
            </div>
            <div className="bp-actions-panel-list">
              {BP_ACTION_ITEMS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={`bp-actions-panel-item${item.key === 'bill-payment' ? ' is-primary' : ''}`}
                  onClick={() => this.runAction(item)}
                >
                  <span className={`bp-actions-panel-icon mdi ${item.icon || 'mdi-chevron-right'}`} />
                  <span className="bp-actions-panel-label">{item.label}</span>
                  <span className="mdi mdi-chevron-right bp-actions-panel-chevron" />
                </button>
              ))}
            </div>
            <div className="bp-actions-panel-footer">
              <button type="button" className="bp-actions-panel-cancel" onClick={this.closeAll}>
                Close
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.overlayOpen}
          onRequestClose={this.closeOverlayOnly}
          ariaHideApp={false}
          style={bpActionOverlayModalStyle}
          contentLabel={this.state.overlayTitle || 'BP Action'}
        >
          <div className="bp-actions-iframe-header">
            <h5 className="bp-actions-iframe-title">{this.state.overlayTitle}</h5>
            <button
              type="button"
              className="bp-actions-panel-close"
              onClick={this.closeOverlayOnly}
              aria-label="Close"
            >
              <span className="mdi mdi-close" />
            </button>
          </div>
          {this.state.overlayPost && (
            <form
              ref={this.formRef}
              method="POST"
              target={this.frameName}
              action={this.state.overlayPostAction}
              style={{ display: 'none' }}
            >
              <input type="hidden" name={this.state.overlayPostField} value={this.state.overlayBn || ''} />
              <input type="hidden" name="user_id" value={localStorage.getItem('UserId') || ''} />
            </form>
          )}
          <iframe
            name={this.frameName}
            title="BP Action"
            className="bp-actions-iframe"
            src={this.state.overlayPost ? 'about:blank' : this.state.overlayUrl}
          />
        </Modal>
      </>
    );
  }
}

export default withRouter(BpActionsOverlay);
